import type { Corral } from "shared/types";
import { CorralFilterFormState } from "../corral.types";

export enum CorralListTableColumn {
  Retreat = "retreat",
  Name = "name",
  ShortName = "short-name",
  AnimalCount = "animal-count",
  Edit = "edit",
  Delete = "delete",
}

function isFilteredByName(name: string, searchText: string): boolean {
  if (searchText.trim() === "") {
    return true;
  }

  return name.toUpperCase().includes(searchText.trim().toUpperCase());
}

export function filterCorralPredicate(
  item: Corral,
  filter: CorralFilterFormState
): boolean {
  const matchesSearchText = isFilteredByName(item.name, filter.searchText);

  return matchesSearchText;
}
